// Build filters for backend API and search URL
function buildFilters({ 
  locations = [], 
  property_type, 
  transaction_type, 
  mts_min, 
  mts_max, 
  bedrooms, 
  baths,
  price_min,
  price_max
}) {
  const filters = {
    locations: locations.map(opt => ({ id: opt.id, nombre: opt.nombre })),
    property_type: property_type,
    transaction_type: transaction_type,
  };
  
  if (mts_min) filters.mts_min = mts_min;
  if (mts_max) filters.mts_max = mts_max;
  if (price_min) filters.price_min = price_min;
  if (price_max) filters.price_max = price_max;
  
  // Handle arrays for bedrooms and bathrooms
  if (bedrooms && bedrooms.length > 0) filters.bedrooms = bedrooms;
  if (baths && baths.length > 0) filters.baths = baths;

  // Serialize locations as JSON for query string
  const queryString = Object.entries(filters)
    .filter(([_, v]) => v !== undefined && v !== '' && v !== null)
    .map(([k, v]) => {
      if (k === 'locations') {
        return `${encodeURIComponent(k)}=${encodeURIComponent(JSON.stringify(v))}`;
      } else if (Array.isArray(v)) {
        // Handle arrays (bedrooms, baths) as JSON
        return `${encodeURIComponent(k)}=${encodeURIComponent(JSON.stringify(v))}`;
      }
      return `${encodeURIComponent(k)}=${encodeURIComponent(v)}`;
    })
    .join('&');

  return { filters, queryString };
}

// Parse URL query parameters and return applied filters
function parseFiltersFromUrl(query) {
  const result = {};
  
  if (query.locations) {
    try {
      result.locations = JSON.parse(query.locations);
    } catch {
      result.locations = [];
    }
  }
  
  if (query.property_type) result.property_type = query.property_type;
  if (query.transaction_type) result.transaction_type = query.transaction_type;
  if (query.propertyType) result.property_type = query.propertyType; // Support both formats
  if (query.transactionType) result.transaction_type = query.transactionType; // Support both formats
  
  if (query.mts_min) result.mts_min = parseInt(query.mts_min);
  if (query.mts_max) result.mts_max = parseInt(query.mts_max);
  if (query.price_min) result.price_min = parseInt(query.price_min);
  if (query.price_max) result.price_max = parseInt(query.price_max);
  
  // Handle bedrooms and bathrooms as arrays
  if (query.bedrooms) {
    if (Array.isArray(query.bedrooms)) {
      result.bedrooms = query.bedrooms;
    } else if (typeof query.bedrooms === 'string') {
      // Support comma-separated values or JSON array
      try {
        result.bedrooms = JSON.parse(query.bedrooms);
      } catch {
        result.bedrooms = query.bedrooms.split(',').map(v => v.trim());
      }
    } else {
      result.bedrooms = [query.bedrooms.toString()];
    }
  }
  
  if (query.baths) {
    if (Array.isArray(query.baths)) {
      result.baths = query.baths;
    } else if (typeof query.baths === 'string') {
      // Support comma-separated values or JSON array
      try {
        result.baths = JSON.parse(query.baths);
      } catch {
        result.baths = query.baths.split(',').map(v => v.trim());
      }
    } else {
      result.baths = [query.baths.toString()];
    }
  }
  
  return result;
}

// Convert frontend filter format to backend API format
function normalizeFilters(frontendFilters) {
  const normalized = {};
  
  // Handle transaction type
  if (frontendFilters.type) {
    normalized.transaction_type = frontendFilters.type;
  }
  
  // Handle property type - default to 'casa' if not specified
  normalized.property_type = frontendFilters.property_type || 'casa';
  
  // Handle price range
  if (frontendFilters.priceRange) {
    if (frontendFilters.priceRange[0]) normalized.price_min = frontendFilters.priceRange[0];
    if (frontendFilters.priceRange[1]) normalized.price_max = frontendFilters.priceRange[1];
  }
  
  // Handle square feet range (metros cuadrados)
  if (frontendFilters.squareFeetRange) {
    if (frontendFilters.squareFeetRange[0]) normalized.mts_min = frontendFilters.squareFeetRange[0];
    if (frontendFilters.squareFeetRange[1]) normalized.mts_max = frontendFilters.squareFeetRange[1];
  }
  
  // Handle bedrooms and bathrooms (now supports multiple values)
  if (frontendFilters.beds && frontendFilters.beds.length > 0) {
    normalized.bedrooms = frontendFilters.beds;
  }
  if (frontendFilters.baths && frontendFilters.baths.length > 0) {
    normalized.baths = frontendFilters.baths;
  }
  
  // Handle locations
  if (frontendFilters.locations) normalized.locations = frontendFilters.locations;
  
  // Copy other properties directly
  Object.keys(frontendFilters).forEach(key => {
    if (!['type', 'priceRange', 'squareFeetRange', 'beds', 'baths'].includes(key)) {
      if (frontendFilters[key] !== undefined && frontendFilters[key] !== null && frontendFilters[key] !== '') {
        normalized[key] = frontendFilters[key];
      }
    }
  });
  
  // Clean up empty arrays
  if (normalized.bedrooms && normalized.bedrooms.length === 0) {
    delete normalized.bedrooms;
  }
  if (normalized.baths && normalized.baths.length === 0) {
    delete normalized.baths;
  }
  
  return normalized;
}

export { buildFilters, parseFiltersFromUrl, normalizeFilters };